import styled from 'styled-components';
import { primaryColor, errorColor, secondaryInfoColor, infoGrey } from '~theme';

export const FormWrapper = styled.form`
  min-height: 500px;
  padding: 16px 0px;
`;

export const FormHeader = styled.h4`
  color: ${primaryColor};
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;

  font-weight: 400;
  font-size: 28px;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: ${props => (props.column ? 'column' : 'row')};
  align-items: flex-start;
  @media (max-width: 767px) {
    flex-direction: ${props => (props.reverse ? 'column-reverse' : 'column')};
  }
  > div {
    ${props =>
      props.gutter && props.column
        ? `margin-bottom:${props.gutter}px`
        : `margin-right:${props.gutter}px`};
  }
`;

export const Buttons = styled.div`
  margin: 12px 0 16px;
  display: flex;
  gap: 16px;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  & > button {
    flex-grow: 1;
    flex-basis: 100%;
  }
`;

export const BarcodeButton = styled.button`
  padding: 12px 0px;
  outline: none;
  border: none;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  width: 100%;
  white-space: nowrap;
  background-color: ${primaryColor};
  margin-bottom: 32px;
`;

export const InfoLabel = styled.div`
  word-break: break-word;
  padding: 8px;
  background-color: #fff;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid
    ${props =>
      props.alertLevel === 'LEVEL_WARNING' ? errorColor : secondaryInfoColor};
  color: ${props =>
    props.alertLevel === 'LEVEL_WARNING' ? errorColor : secondaryInfoColor};
`;

export const ErrorMessage = styled.div`
  margin-top: 8px;
  color: ${errorColor};
  visibility: ${props => (props.isVisible ? 'visible' : 'hidden')};
  font-size: 16px;
`;

export const FormNotFound = styled.h3`
  color: ${errorColor};
`;

export const InfoText = styled.div`
  color: ${infoGrey};
  ${props => props.openHours && 'margin-top: 24px'};
  > img,
  > div {
    display: inline-block;
    vertical-align: middle;
  }
  > div {
    width: calc(98% - 30px);
  }
`;

export const WarningText = styled.div`
  margin-top: 16px;
  display: flex;
  margin-bottom: 5px;
  align-items: center;
  margin-left: 8px;
  color: ${errorColor};
`;

export const FlexCol = styled.div`
  flex: ${props => (props.flex ? props.flex : 'none')};
  display: flex;
  align-items: center;
`;
